module.exports = (s) => {
  return [{
    name: 'ID',
    value: 'id',
    props: {
      width: 100,
    },
  },
  {
    name: '所属游戏',
    value: 'game.name',
    props: {
      width: 300,
    },
  },
  {
    name: '标签',
    value: 'label',
    format: (row) => {
      const h = s.$createElement;
      return row.editable ? h('div', {
        class: 'flex items-center',
      }, [
        h('el-input', {
          class: 'mr-10',
          props: {
            size: 'mini',
            value: row.label,
            clearable: true,
            showWordLimit: true,
          },
          attrs: {
            placeholder: '请输入标签',
            maxlength: 10,
          },
          on: {
            input: (val) => {
              row.label = val;
            },
          },
        }),
        h('el-button', {
          props: {
            type: 'warning',
            size: 'mini',
            disabled: row.loading,
          },
          on: {
            click: () => {
              s.$set(row, 'label', row.backup_label);
              s.$set(row, 'level', row.backup_level);
              s.$set(row, 'editable', false);
            },
          },
        },
        '取消编辑'),
      ]) : row.label;
    },
  },
  {
    name: '标签等级',
    value: 'level',
    format: (row) => {
      const h = s.$createElement;
      const level_options = [
        { label: '一级标签', value: 1 },
        { label: '二级标签', value: 2 },
      ];
      const level_map = {
        1: '一级标签',
        2: '二级标签',
      };
      return row.editable ? h('div', {
        class: 'flex items-center',
      }, [
        h('el-select', {
          class: 'mr-10',
          props: {
            size: 'mini',
            value: row.level,
            placeholder: '请选择标签等级',
          },
          on: {
            change: (val) => {
              row.level = val;
            },
          },
        }, level_options.map(({ label, value }) => {
          return h('el-option', { props: { label, value }}, null);
        })),
        h('el-button', {
          props: {
            type: 'warning',
            size: 'mini',
            disabled: row.loading,
          },
          on: {
            click: () => {
              s.$set(row, 'label', row.backup_label);
              s.$set(row, 'level', row.backup_level);
              s.$set(row, 'editable', false);
            },
          },
        },
        '取消编辑'),
      ]) : level_map[row.level];
    },
  },
  {
    name: '操作',
    props: {
      width: 100,
    },
    format: (row) => {
      const h = s.$createElement;
      return h('div', null, [
        row.editable ? h('el-button', {
          props: {
            type: 'success',
            size: 'mini',
            disabled: row.loading,
          },
          on: {
            click: () => {
              s.onEditMaterialLabel(row);
            },
          },
        }, '确认更新') : h('el-button', {
          props: {
            type: 'primary',
            size: 'mini',
            disabled: row.loading,
          },
          on: {
            click: () => {
              s.$set(row, 'backup_label', row.label);
              s.$set(row, 'backup_level', row.level);
              s.$set(row, 'editable', true);
            },
          },
        }, '编辑'),
      ]);
    },
  }];
};
